import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Col, Row } from 'react-bootstrap'
import { Form, Input, Checkbox } from 'formsy-react-components';
import { ContainerBox } from '../admin/AdminStyle';
import { LogeButtonSlim, Black, BlackHeading1 } from '../GeneralStyle'
import { Spacer, SubHeading, InverseH3 } from './GolfTournamentStyle'

@inject('tournamentStore', 'userStore')

@observer
class GolfTournament extends Component {

  onSubmit = (data) => {

    // let me = this.props.userStore.me

    const tournament = this.props.tournamentStore.currentTournament.id

    const externalParticipant = {
      firstname: data.guestfirstname,
      lastname: data.guestlastname,
      handicap: data.guesthcp
    }

    if ((data.guestfirstname === undefined) || (data.guestlastname === undefined) || (data.guesthcp === undefined)) {
      // nothing
    } else {
      this.props.tournamentStore.register({
        tournament, externalParticipant, hcpParticipant: data.hcp, onlyEvent: data.onlyEvent, guestOnlyEvent: data.guestOnlyEvent,
      })
    }

  }

  componentWillMount() {
    this.props.tournamentStore.getCurrentTournament()
  }

  render() {
    const isDefaultRequiredValue = 'Das ist ein Pflichtfeld.';

    const { me } = this.props.userStore
    const tournamentStore = this.props.tournamentStore
    const { currentTournament } = this.props.tournamentStore
    // console.log(currentTournament);

    if(!currentTournament) return (<div>loading</div>)

    const date = new Date(currentTournament.get('date') )
    const weekDays = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
    const dateString = `${weekDays[date.getDay()]}, ${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`


    const extraData = currentTournament.get('extraData')

    return (
      <div>
        <ContainerBox>
          <Row>
            <Col xs={12} style={{ padding: 0 }}>
              <Spacer />
              <Row>
                <Col md={12}>
                  <BlackHeading1 className={"blackboard-heading"} >ANMELDUNG { currentTournament.get('name') }</BlackHeading1>
                </Col>
              </Row>
              <Spacer />
              <Row style={{ background: 'linear-gradient(to right bottom,#e3c791,#ba9657)', paddingTop: 15, paddingBottom: 50 }}>
                <Col xsOffset={1} xs={10}>
                  <Col md={4}>
                    <InverseH3>Wann & wo?</InverseH3>
                    <div style={{ margin: 'auto', borderBottom: "1px solid rgb(33,45,61,15%)", width: "35%", marginBottom: 10 }}></div>
                    <Black style={{ fontSize: 14, paddingTop: 25, textAlign: 'center', color: 'white ' }}>
                      { dateString }<br /><br />
                      { currentTournament.get('golfCourse') }<br /><br />
                      { currentTournament.get('location') }
                      <br /><br />
                      { extraData && extraData.location }<br />
                    </Black>
                  </Col>
                  <Col md={4}>
                    <InverseH3>Wie?</InverseH3>
                    <div style={{ margin: 'auto', borderBottom: "1px solid rgb(33,45,61,15%)", width: "35%", marginBottom: 10 }}></div>
                    <Black style={{ fontSize: 14, paddingTop: 25, textAlign: 'center', color: 'white ' }}>
                      { currentTournament.get('gameMode') } <br /><br />
                      Maximal { currentTournament.get('participantCount') } Teams ({ currentTournament.get('participantCount') * currentTournament.get('teamSize') } einzelne SpielerInnen)
                      <br /><br />
                      { extraData && extraData.how }<br />
                    </Black>
                  </Col>
                  <Col md={4}>
                    <InverseH3>Kosten?</InverseH3>
                    <div style={{ margin: 'auto', borderBottom: "1px solid rgb(33,45,61,15%)", width: "35%", marginBottom: 10 }}></div>
                    <Black style={{ fontSize: 14, paddingTop: 25, textAlign: 'center', color: 'white ' }}>
                      € { currentTournament.get('price') } pro TEAM (für { currentTournament.get('teamSize') } Personen)
                      <br /><br />
                      { extraData && extraData.cost }<br />
                    </Black>
                  </Col>
                </Col>
              </Row>
            </Col>
          </Row>

          <Spacer />

          {(!tournamentStore.registered && !tournamentStore.isError) ? (
            <Row>
              <Col xsOffset={0} xs={12} mdOffset={2} md={8}>
                <Form
                  className={'dashboard-form'}
                  onSubmit={this.onSubmit}
                  onChange={this.updateStates}
                  layout={'vertical'}
                  validateOnSubmit={false}
                  validatePristine={false}
                  formNoValidate
                  noValidate
                >
                  <Row>
                    <Col md={6}>

                      <SubHeading>
                        Erster Spieler
        </SubHeading>
                      <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>
                    </Col>
                  </Row>
                  <Row>
                    <div style={{ marginLeft: 15, marginRight: 15 }}>
                      <Col md={6}>
                        <Input
                          style={{ fontSize: 14 }}
                          disabled
                          name="firstname"
                          value={me.firstname}
                          type="text"
                          validationErrors={{ isDefaultRequiredValue }}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          style={{ fontSize: 14 }}
                          disabled
                          name="lastname"
                          value={me.lastname}
                          type="text"
                          validationErrors={{ isDefaultRequiredValue }}
                          required
                        />
                      </Col>
                    </div>
                  </Row>

                  <Row>
                    <div style={{ marginLeft: 15, marginRight: 15 }}>
                      <Col md={6}>
                        <Input
                          style={{ fontSize: 14 }}
                          disabled
                          name="company"
                          value={me.company.name}
                          type="text"
                          validationErrors={{ isDefaultRequiredValue }}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          style={{ fontSize: 14 }}
                          disabled={ ((me.handicap != null) || (me.handicap != undefined)) ? true : false}
                          name="hcp"
                          placeholder="HCP"
                          value={me.handicap}
                          type="number"
                          validationErrors={{ isDefaultRequiredValue }}
                          required
                        />
                      </Col>
                    </div>
                  </Row>
                  <Row>
                    <div style={{ marginLeft: 15, marginRight: 15, color: "#555" }}>
                      <Col md={6}>
                      <Checkbox
                          name="onlyEvent"
                          label="+1 Abend Begleitperson"
                      />
                      </Col>
                    </div>
                  </Row>
                  <Spacer />
                  <Row>
                    <Col md={6}>
                      <SubHeading>
                        Zweiter Spieler
        </SubHeading>
                      <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>

                    </Col>
                  </Row>
                  <Row>
                    <div style={{ marginLeft: 15, marginRight: 15 }}>
                      <Col md={6}>
                        <Input
                          style={{ fontSize: 14 }}
                          name="guestfirstname"
                          placeholder="Vorname"
                          type="text"
                          validationErrors={{ isDefaultRequiredValue }}
                          required
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          style={{ fontSize: 14 }}
                          name="guestlastname"
                          placeholder="Nachname"
                          type="text"
                          validationErrors={{ isDefaultRequiredValue }}
                          required
                        />
                      </Col>
                    </div>
                  </Row>

                  <Row>
                    <div style={{ marginLeft: 15, marginRight: 15 }}>
                      <Col md={6}>
                        <Input
                          style={{ fontSize: 15 }}
                          placeholder="HCP"
                          name="guesthcp"
                          type="text"
                          validationErrors={{ isDefaultRequiredValue }}
                          required
                        />
                      </Col>
                    </div>
                  </Row>
                  <Row>
                    <div style={{ marginLeft: 15, marginRight: 15, color: "#555" }}>
                      <Col md={6}>
                      <Checkbox
                          name="guestOnlyEvent"
                          label="+1 Abend Begleitperson"
                      />
                      </Col>
                    </div>
                  </Row>
                  <Spacer />
                  <Row style={{
                    display: "flex",
                    justifyContent: "center",
                  }}>
                    <LogeButtonSlim
                      style={{
                        margin: "0 auto"
                      }}
                      hoverFontColor={"white"}
                      disabled={tournamentStore.loading}
                    >
                      {tournamentStore.loading ? ("Lade ...") : ("verbindlich anmelden")}
                    </LogeButtonSlim>
                  </Row>
                </Form>
                <Spacer />
              </Col>
            </Row>

          ) :
            tournamentStore.isError ? (<Row>
              <Col md={12} style={{ textAlign: "center" }}>
                <InverseH3 style={{ color: 'black' }}>Anmeldung nicht möglich!</InverseH3>
                <Spacer />
                <Black style={{ fontSize: 14, textAlign: 'center' }}>
                  Sie sind bereits beim Turnier angemeldet.</Black><br />
                <Black style={{ margin: 'auto', fontSize: 14, textAlign: 'center', maxWidth: 350 }}> Sollten Sie weitere Hilfe hierbei benötigen, können Sie sich gerne an uns direkt via Mail unter <a style={{ color: '#DAB777', fontWeight: 'bold' }} href="mailto:l.wuester@the-loge.com">l.wuester@the-loge.com</a> wenden!
        </Black>
                <Spacer />
              </Col>
            </Row>)
              : (

                <Row>
                  <Col md={12} style={{ textAlign: "center" }}>
                    <InverseH3 style={{ color: 'black' }}>Anmeldung erfolgreich!</InverseH3>
                    <Spacer />
                    <Black style={{ fontSize: 14, textAlign: 'center' }}>
                      Die Bestätigung finden Sie in Ihrem E-Mail Postfach.
            </Black><br />
                    <Black style={{ margin: 'auto', fontSize: 14, textAlign: 'center', maxWidth: 350 }}> Sollten Sie keine E-Mail erhalten haben, können Sie sich gerne an uns direkt via Mail unter <a style={{ color: '#DAB777', fontWeight: 'bold' }} href="mailto:l.wuester@the-loge.com">l.wuester@the-loge.com</a> wenden!
        </Black>
                    <Spacer />
                  </Col>
                </Row>

              )}

          <Spacer />
        </ContainerBox>
      </div>
    );
  }
}

export default GolfTournament



// WEBPACK FOOTER //
// /src/components/internal/GolfTournament.js